<template>
  <div
    id="upload"
    class="position-fixed fixed-top h-100 w-100 d-flex align-items-center justify-content-center"
    @click.self="isShow(false)"
  >
    <div class="box">
      <div class="row">
        <div class="col-9 h2">รูปปกข่าว</div>
        <div class="col-3 text-end">
          <button
            v-if="canEdit"
            :disabled="!fileChose"
            class="btn sc-btn sc-btn-opaque"
            @click="save"
          >
            บันทึก
          </button>
        </div>
      </div>
      <div class="row mx-auto">
        <div class="col-12 p-0 mt-4">
          <croppa
            v-model="coverImg"
            :accept="'image/*'"
            :placeholder="''"
            :file-size-limit="upload.MAX_FILE_SIZE_B"
            :width="375"
            :height="160"
            :show-remove-button="false"
            :replace-drop="true"
            :initial-image="image"
            class="upload-box dropzone"
            @file-size-exceed="fileSizeExceed()"
            @file-choose="filesChange()"
          >
            <div class="upload-placeholder">
              <img :src="'/static/icons/button-add-cover.svg'" />
              <div>
                เพิ่มรูปภาพ<br /><br />
                (คลิก หรือลากไฟล์ลงในกรอบนี้)
              </div>
            </div>
          </croppa>
          <img
            v-if="fileChose && canEdit"
            src="/static/icons/cancel-black.svg"
            class="btn-remove pointer"
            @click="removeFile()"
          />
          <div class="remake">
            {{ "* " + $t("feature.upload.cover_resolution_label") }}
            {{ $t("and") }}
            {{
              `${$t("feature.upload.condition_label")} ${labels.maxFileSize} MB`
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UPLOAD } from "@/config/constant"

export default {
  props: {
    coverUrl: {
      type: null,
      default: undefined,
    },
    coverKey: {
      type: null,
      default: undefined,
    },
    canEdit: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      coverImg: "",
      image: this.coverUrl,
      file: "",
      key: this.coverKey,
      labels: {
        maxFileSize: UPLOAD.MAX_FILE_SIZE_MB,
      },
      fileChose: !!this.coverUrl,
      upload: UPLOAD,
    }
  },
  methods: {
    filesChange() {
      this.key = ""
      this.fileChose = true
    },
    fileSizeExceed() {
      this.fileChose = false
      this.$message.error(
        `${this.$t("feature.upload.exceed_max_file_size")} ${
          UPLOAD.MAX_FILE_SIZE_MB
        } MB`,
      )
    },
    isShow() {
      this.$emit("isshow", false)
    },
    async save() {
      this.image = this.coverImg.generateDataUrl()
      this.file = await this.coverImg.promisedBlob()
      this.$emit("save", this.image, this.file, this.key)
      this.$emit("isshow", false)
      this.$emit("setEdit")
    },
    removeFile() {
      this.fileChose = false
      this.coverImg.remove()
    },
  },
}
</script>

<style lang="scss" scoped>
#upload {
  background-color: rgba(74, 74, 74, 0.5);
}
.box {
  background-color: #fff;
  border-radius: 15px;
  padding: 35px;
}
.upload-box {
  position: relative;
  width: 379px;
  height: 164px;
  border: 2px dashed #d8d6d9;

  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: center;
  color: #8c8786;
  object-fit: cover;

  &.overlay {
    position: absolute;
    top: 0;
    left: 0;
  }
}
.upload-placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
.upload-box.croppa--has-target .upload-placeholder {
  display: none;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  left: 0;
  width: 360px;
  height: 154px;
  position: absolute;
  cursor: pointer;
  z-index: 99;
}
.btn-remove {
  position: absolute;
  width: 25px;
  height: 25px;
  top: -10px;
  right: -10px;
}
.show-file {
  width: 360px;
  height: 154px;
}
.remake {
  font-size: 11px;
  font-weight: normal;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
  margin-top: 16px;
  text-align: center;
}
</style>
